import layout from '../layout'
export default function makeSeriesRoutes({
  contentType,
  components: { SeriesListingContainer }
}) {

  return [
    {
      path: '/',
      component: layout,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: `/${contentType.name}/list/:categoryId`,
          component: SeriesListingContainer,
          props: {
            contentType,
          }
        },
      ]
    },
  ];
}
